import React, { FC } from 'react';
import styled from 'styled-components';

import { useMediaQuery } from '@crehana/react-hooks';
import { ShoppingCartLight, ShoppingCartAdded } from '@crehana/icons';

import { IconButton, colors, PrimaryButton } from '@crehana/ui';
import { useTranslation } from '@crehana/i18n';

const StyledIconButton = styled(({ inShoppingCart, isDark, ...rest }) => (
  <IconButton {...rest} />
))<{
  inShoppingCart?: boolean;
}>`
  border: 2px solid
    ${({ isDark, theme }) =>
      isDark ? theme.colors.white : theme.colors.primary.main};
  margin-right: ${({ theme }) => theme.spacing[12]};
  transform: translate(0, 0);
  transition: all 0.2s ease-out;
  ${props =>
    props.inShoppingCart &&
    `background-color: ${props.theme.colors.primary.main};`}

  &:hover {
    transform: translate(0, -2px);
    box-shadow: 0px 2px 6px rgba(92, 84, 122, 0.2);
  }
`;

interface IClassicAddToCartBtn {
  isDark?: boolean;
  inShoppingCart?: boolean;
  loadingCart?: boolean;
  handleAddToCart: () => void;
  handleDirectBuyButton: () => void;
}
const ClassicAddToCartBtn: FC<IClassicAddToCartBtn> = ({
  isDark,
  inShoppingCart,
  handleAddToCart,
  handleDirectBuyButton,
  loadingCart,
}) => {
  const { t } = useTranslation();
  const { matches: isMd } = useMediaQuery('md');
  const { matches: isSm } = useMediaQuery('sm');
  const isTablet = isSm && !isMd;

  return (
    <div className="flex items-center justify-between pt-16 AddToCartComponent">
      <StyledIconButton
        onClick={handleAddToCart}
        customIcon={inShoppingCart ? ShoppingCartAdded : ShoppingCartLight}
        customColor={
          isDark
            ? colors.white
            : inShoppingCart
            ? colors.purpleLighter
            : colors.primaryMain
        }
        customSize={inShoppingCart ? 20 : 24}
        disabled={loadingCart}
        inShoppingCart={inShoppingCart}
        isDark={isDark}
        aria-label="add-to-cart"
        className="rounded-10"
      />
      <PrimaryButton
        full
        style={{
          paddingLeft: isSm ? 8 : undefined,
          paddingRight: isSm ? 8 : undefined,
        }}
        onClick={handleDirectBuyButton}
        label={t(isTablet ? 'BUY' : 'BUY_NOW', {
          defaultValue: 'Comprar ahora',
        })}
        isDark={isDark}
        className="rounded-10"
      />
    </div>
  );
};

export default ClassicAddToCartBtn;
